let _isDev: boolean | undefined = undefined;

export function isDev() {
  if (_isDev === undefined) {
    const env$ = document.head.querySelector(`meta[name='env']`);
    _isDev = env$?.getAttribute('content') === 'development';
  }

  return _isDev;
}
